import React, {useEffect, useState, useCallback, useRef} from 'react';
import {useDispatch} from 'react-redux';
import {Menu} from '../../utils/menu/Menu';
import {formatErrors} from '../../constants';
import {toast} from 'react-toastify';
import {SortItem} from '../../utils/sortItem/SortItem';
import {ButtonMore} from '../../utils/buttonMore/buttonMore';
import {Pagination} from '../../utils/pagination/Pagination';
import {ConfirmModal} from "../../utils/confirm/ConfirmModal";
import {FaqModal} from "./utils/FaqModal";
import { deleteFaqAction, getFaqAction, getFaqCategoriesAction } from '../../actions/faqAction';
import { useParams } from 'react-router-dom';
import { InputSearch } from '../../utils/inputSearch/InputSearch';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const Faq = (props) => {
  const dispatch = useDispatch();
  const {categoryId} = useParams();
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({});
  const [categories, setCategories] = useState({});
  const [catID, setCatID] = useState(0);
  const [opened, setOpened] = useState({});
  const abortRef = useRef(null);

  const handleChangeFilter = useCallback((field, value) => {
      setFilter((data) => {
        return {...data, [field]: value, page: 1}
      });
    }, []);

  const handleChangePage = useCallback((value) => {
    setFilter((data) => {
      return {...data, page: value}
    });
  }, []);

  // get list
  const getList = useCallback((filter) => {
    if (abortRef && abortRef.current) {
      abortRef.current.abort();
    }
    const abortNew = new AbortController();
    abortRef.current = abortNew;
    dispatch(getFaqAction(filter, abortRef && abortRef.current ? abortRef.current.signal : null)).then((data) => {
      abortRef.current = null;
      setItems(data.items || []);
      setTotal(data.total);
      localStorage.setItem('dc_FaqFilter', JSON.stringify(filter));
    }).catch(err => {
      if (err.name !== 'AbortError') {
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      }
      abortRef.current = null;
    });
  }, [dispatch]);

  const handleDelete = (id) => {
    return new Promise((resolve, reject) => {
      if (loading) {
        return resolve(false);
      }
      setLoading(true);
      dispatch(deleteFaqAction(id)).then(() => {
        setLoading(false);
        resolve(true);
        toast.success('Вопрос удален', {position: toast.POSITION.BOTTOM_RIGHT});
        if (filter.page > 1 && (filter.page - 1) * filter.limit >= total - 1) {
          setFilter({...filter, page: filter.page - 1});
        } else {
          getList(filter);
        }
      }).catch(err => {
        setLoading(false);
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        reject(err);
      });
    });
  };

  const toggle = (id) => {
    setOpened((data) => {
      return {...data, [id]: !data[id]}
    });
  };

  useEffect(() => {
    dispatch(getFaqCategoriesAction()).then((data) => {
      setCategories((data.items || []).reduce((res, i) => {
        res[i.id] = i.name;
        return res;
      }, {}));
    }).catch(err => {
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }, [dispatch]);

  // get list on change filter
  useEffect(() => {
    if (filter.page) {
      getList(filter);
    }
  }, [filter, getList]);

  useEffect(() => {
    const baseFilter = {page: 1, limit: 10, category_id: 0, search: ''};
    let curFilter = localStorage.getItem('dc_FaqFilter');
    curFilter = curFilter ? JSON.parse(curFilter) : baseFilter;
    curFilter.page = !curFilter.page ? 1 : curFilter.page;
    const catID = categoryId ? parseInt(categoryId, 10) : 0;
    setCatID(catID);
    if (catID !== curFilter.category_id) {
      curFilter.category_id = catID;
      curFilter.page = 1;
    }
    setFilter(curFilter);
  }, [categoryId]);

  return <div className="content">
    <Menu isStatic={true}/>

    <div className="heading heading--flex">
      <h2 className="heading__title">
        База знаний: {catID ? categories[catID] : 'Все категории'}
      </h2>
      {filter.page && filter.page > 0 && <InputSearch className="heading__input"
                                                      value={filter.search}
                                                      loading={loading}
                                                      handleChange={handleChangeFilter} />}
      
      {filter.page && <FaqModal onSuccess={() => getList(filter)} triggerWrap={true} categoryId={catID} trigger={<button type="button" className="heading__btn heading__btn--invite btn modal-btn">+ Добавить</button>} />}
      <Link to="/faq-categories" className="heading__btn heading__btn--invite btn modal-btn" style={{"marginLeft": "10px"}}>Категории</Link>
    </div>
    <div className="users">
      <div className="users__wrapper">
        <div className="sort">
          <SortItem title="Вопрос" className="sort__item--name"/>
          <SortItem title="Категория" className="sort__item--email"/>
          <SortItem title="Изменен" className="sort__item--course"/>
        </div>
        <div className="users__inner">
          {
            items && items.length > 0 && items.map((i) => <div key={i.id} className={"users__item users__item-multi" + (opened[i.id] ? " opened" : "")} onClick={() => toggle(i.id)}>
              <span className="users__name">{i.question}</span>
              <span className="users__email">{i.category_id ? categories[i.category_id] : "[Без категории]"}</span>
              <span className="users__course">{i.updated.split('.')[0].split('T').join(' ')}</span>
              <ButtonMore>
                <ul className="dropdown">
                  <li>
                    <FaqModal trigger={<div className="dropdown__item icon-edit">Редактировать</div>} triggerWrap={false} item={i} onSuccess={() => getList(filter)}/>
                  </li>
                  <li>
                    <ConfirmModal trigger={<div className="dropdown__item icon-delete">Удалить</div>} triggerWrap={false} title={"Удалить запись?"} handleOk={() => handleDelete(i.id)}/>
                  </li>
                </ul>
              </ButtonMore>
              <div className="users__break"></div>
              <div className="users__name users__name-second">
              {i.answer}
                
              </div>
            </div>)
          }
        </div>
      </div>
    </div>

    {filter.page && filter.page > 0 && <Pagination page={filter.page} total={total} limit={filter.limit} onChange={handleChangePage}/>}
  </div>;
};


export default Faq
